'use strict';

export default () => {
  const items = document.querySelectorAll(".teams__vacancies-item");

  items.forEach(item => {
    const question = item.querySelector(".teams__vacancies-item__header");

    question.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });
}
